import React from 'react'
import RecordNavigatorStyle from './css/RecordNavigatorStyle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function RecordNavigator(props) {
  const { totalPage, getTotalRecords } = props
  const [page, setPage] = props.page
  const [recPP, setRecPP] = props.recPP
  const [recordPerPage, setRecordPerPage] = props.recordPerPage

  const onSetRecordPerPage = () => {
    if (recPP >= 1) setRecordPerPage(recPP)
    else {
      setRecordPerPage(1)
      setRecPP(1)
    }
    setPage(1)
  }

  const onPreviousPage = () => {
    if (totalPage > 0) (page === 1) ? setPage(totalPage) : setPage(page - 1)
  }
  const onNextPage = () => {
    if (totalPage > 0) (page === totalPage) ? setPage(1) : setPage(page + 1)
  }

  const onKeyDown = (e) => (e.key === 'Enter') ? onSetRecordPerPage() : e

  return (
    <React.Fragment>
      <div className="total-records-container">
        <label htmlFor='total-records'>Total Records:</label>
        <span>{' '}</span>
        <div className='total-records'>{getTotalRecords()}</div>
      </div>
      <div className="records-per-page-container">
        <label htmlFor='records-per-page'>Records/Page:</label>
        <span>{' '}</span>
        <input
          className='records-per-page'
          type='number'
          min='1'
          style={{backgroundColor: (recPP !== recordPerPage) ? 'red' : 'transparent'}}
          onChange={(e) => setRecPP((e.target.value === '') ? '' : parseInt(e.target.value))}
          onKeyDown={onKeyDown}
          value={(recPP) ? recPP : ''}
        />
        <button
          className='pospro-action-btn'
          onClick={onSetRecordPerPage}>
          Set
        </button>
      </div>

      <div className='record-navigator-container'>
        <div className="record-navigator">
          <button
            className='btn-nav-prev'
            onClick={onPreviousPage}
            > <FontAwesomeIcon icon='angle-left'/>
          </button>
          <span className='page'>{page}</span>&nbsp;{'-'}&nbsp;<span className='total-page'>{!isNaN(totalPage) ? totalPage : 0}</span>
          <button
            className='btn-nav-next'
            onClick={onNextPage}
            > <FontAwesomeIcon icon='angle-right'/>
          </button>
        </div>
      </div>
      <RecordNavigatorStyle />
    </React.Fragment>
  )
}

export default React.memo(RecordNavigator)
